import { ArrowLeft } from "lucide-react";
import React, { useEffect } from "react";
import { sendStatusBarColor } from "src/helpers/common";

interface HeaderProps {
  className?: string;
  title: string;
  titlePosition?: "left" | "center";
  showBackButton?: boolean;
  onBackClick?: () => void;
  rightComponent?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({
  className,
  title,
  titlePosition = "left",
  showBackButton = true,
  onBackClick,
  rightComponent,
}) => {
  // TEST WIRING: this header is always bg-white, so report that as the
  // native status bar color while it's the mounted header for a screen.
  useEffect(() => sendStatusBarColor("#ffffff", "dark-content"), []);

  return (
    <div
      className={`bg-white border-b border-gray-200 px-4 py-2 flex items-center justify-between ${className}`}
    >
      <div className="flex items-center w-full">
        <div className="w-10 h-10">
          {showBackButton && (
            <button
              className="p-2 rounded-full hover:bg-gray-200 w-10 h-10"
              onClick={onBackClick}
            >
              <ArrowLeft className="w-5 h-5" />
            </button>
          )}
        </div>
        <h1
          className={`text-xl font-semibold text-black line-clamp-1 flex-1 ${
            titlePosition === "center" ? "text-center" : "text-left"
          }`}
        >
          {title}
        </h1>
        <div className="w-10 h-10 flex items-center justify-center">
          {rightComponent}
        </div>
      </div>
    </div>
  );
};

export default Header;
